import React, { Component } from "react";
import styled from "styled-components";
import { ProductConsumer } from "../context";
import { ButtonContainer } from "./Button";
import { Link } from "react-router-dom";
//import { storeProducts } from "../data";
export default class Modal2 extends Component {
 
  render() {
    return (
      <ProductConsumer>
        {value => {
          const { modalOpen2, closeModal2 } = value;
          const { img ,id,title,price} = value.modalProduct;
    
          if (!modalOpen2) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="container">
                  <div className="row">
                    <div
                      className="col-8 mx-auto col-md-6 col-lg-4 p-5 text-center text-capitalize"
                      id="modal"
                    >
                      <h5 onClick={() => {closeModal2();}}>Edit item </h5>
                      <img src={img} className="img-fluid" alt=""  onClick={() => {closeModal2();}} />
                      





                      <form onSubmit= {value.EditonSubmit}>
                  
              <div class="form-group">
                <label for="title">Name</label>
                
                <input type="text" class="form-control" name="title" value={title} onChange={ value.EditonChange } />
              </div>
              <div class="form-group">
                <label for="description">Price:</label>
                <input type="number" class="form-control" name="price"  value={price} onChange={value.EditonChange} />
              </div>
            
              <ButtonContainer cart>
              Submit
                         <button hidden type="submit" class="btn btn-success" >Submit</button>
                        </ButtonContainer> 
        
            </form>
            <Link to="/">
                        <button
                       className="btn btn-outline-danger text-uppercase mb-3 px-5"
                       type="button"
                       onClick={() => {
                          value.delete(id);
                          value.setProducts();
                         closeModal2();
                           }}
                     >
                       Delete
                     </button>
                     </Link>







                      <Link to="/cart" hidden>
                        <ButtonContainer
                          cart
                          onClick={() => {
                            closeModal2();
                          }}
                        >
                           Cart
                        </ButtonContainer>
                      </Link>
                      <br/>
                     
                      
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    );
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  #modal {
    background: var(--mainWhite);
  }
`;